import { createContext, useReducer } from "react";

const dftmenu = [
  [["1", "100", "2", "Dashboard", "Dashboard", "space_dashboard", false]],
  [
    ["1", "200", "2", "RNP", "contact_emergency", "contact_emergency", false],
    [
      ["Consultas", "Consultas", "document_scanner"],
      ["Difuntos", "Difuntos", "document_scanner"],
      ["ArbolGenealogico", "Árbol Genealógico", "document_scanner"],
      ["ActasDeMatrimonio", "Actas De Matrimonio", "document_scanner"],
    ],
  ],
];

export const initialState = {
  token: "",
  id: 0,
  grupo: 0,
  username: "",
  nombre: "NA",
  apellido: "",
  email: "",
  foto: "NA",
  departamento: "",
  oficina: "",
  access: [],
  CanNot: 0,
  msj: [],
  sessionvariable: [],
  refresh: "",
  path: "",
};

function reducer(estado, action) {
  let sessidata = { ...estado.sessionData };
  switch (action.type) {
    case "SESSION_SET_USERNAME":
      sessidata.username = action.payload.username;
      return { ...estado, sessionData: sessidata };
    case "SESSION_STAR_DATA":
      let modulos = action.payload.access_data;
      if (modulos.length > 0) {
        for (let i = 0; i < modulos.length; i++) {
          modulos[i]["mostrar"] = false;
          for (let x = 0; x < modulos[i].permisos.length; x++) {
            modulos[i].permisos[x]["mostrar"] = false;
          }
        }
      }
      sessidata.id = action.payload.id || 0;
      sessidata.nombre = action.payload.first_name || "NA";
      sessidata.apellido = action.payload.last_name || "NA";
      sessidata.foto = action.payload.photo || "NA";
      sessidata.departamento = action.payload.departamento || "";
      sessidata.oficina = action.payload.oficina || "";
      sessidata.access = action.payload.access_data || dftmenu;
      sessidata.token = action.payload.access;
      sessidata.refresh = action.payload.refresh || "NULL";
      return { ...estado, sessionData: sessidata };

    case "CLEAR_SESSION_DATA":
      sessidata.nombre = "NA";
      sessidata.apellido = "NA";
      sessidata.foto = "NA";
      sessidata.departamento = "";
      sessidata.oficina = "";
      sessidata.access = dftmenu;
      sessidata.token = "NA";
      sessidata.refresh = "NULL";
      return { ...estado, sessionData: sessidata };
    case "SESSION_STAR_ID":
      let newid = estado.id;
      if (newid !== action.payload);
      newid = action.payload;
      return { ...estado, id: newid };
    case "SET_SESSION_AUTHDATA":
      estado.sessionData = JSON.parse(action.payload);
      return { ...estado };

    case "SET_SESSION_PATH":
      estado.sessionData.path = action.payload;
      //console.log(" PATH GUARDADO",sessidata.path);
      return { ...estado };
    case "CLEAR_SESSION_VARIABLE":
      estado.sessionData.sessionvariable = [];
      return { ...estado };
    // Add more cases for other actions that update your state
    default:
      return { ...estado };
  }
}

export const ContextSession = createContext({
  sessionData: initialState,
  defaultMenu: dftmenu,
  id: "",
  ip: "",
  sessionStart: () => {},
  setUsername: () => {},
  dispatch: () => {},
  storeAuthData: () => {},
  getGrupo: () => {},
  getAuthData: () => {},
  getDataST: () => {},
  clearSession: () => {},
  setPath: () => {},
  setDataAuth: () => {},
  getMenu: () => {},
  getuid: () => {},
  setVariable: () => {},
  clearVariables: () => {},
  getVariable: () => {},
  getToken: () => {},
  getID: () => {},
  setID: () => {},
  ValidateAccess: () => {},
});

export default function SessionContextProvider({ children }) {
  const [SessionState, SessionStateDispatch] = useReducer(reducer, {
    sessionData: initialState,
    defaultMenu: dftmenu,
  });
  const currentdate = new Date();

  function setID() {
    const datetime =
      "Last Sync: " +
      currentdate.getDate() +
      "/" +
      (currentdate.getMonth() + 1) +
      "/" +
      currentdate.getFullYear() +
      " @ " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    //console.log("SE VA CREAR UN NUEVO ID",datetime);
    SessionStateDispatch({
      type: "SESSION_STAR_ID",
      payload: datetime,
    });
  }

  function setUsername(usuario) {
    SessionStateDispatch({
      type: "SESSION_SET_USERNAME",
      payload: { username: usuario },
    });
  }
  function sessionStart(js) {
    SessionStateDispatch({
      type: "SESSION_STAR_DATA",
      payload: js,
    });
  }
  function setPath(path) {
    //console.log("VAMOS A GUARDAR ESTE PATH",path);
    SessionStateDispatch({
      type: "SET_SESSION_PATH",
      payload: path,
    });
  }
  function setDataAuth() {
    const data = getDataST();
    if (!data) {
      return;
    }
    SessionStateDispatch({
      type: "SET_SESSION_AUTHDATA",
      payload: data,
    });
  }
  function setVariable(id, data) {
    let flag = true;
    let c = 0;

    SessionState.sessionData.sessionvariable.forEach((element) => {
      for (var key in element) {
        if (key === id) {
          SessionState.sessionData.sessionvariable[c] = { [id]: data };

          flag = false;
        }
        c++;
      }
    });
    //this.clearStoreAuthData();

    if (flag) SessionState.sessionData.sessionvariable.push({ [id]: data });

    //this.storeAuthData();
    //this.getDataST();
  }

  function getID() {
    return SessionState.id;
  }

  async function storeAuthData() {
    //console.log('Vamos a GUARDAR DATA',SessionState.sessionData, "LOCATION",window.location.pathname);
    let path = window.location.pathname;
    let dat = SessionState.sessionData;
    dat.path = path;
    localStorage.setItem("authData", JSON.stringify(dat));
    //console.log('DATA GUARDADA',dat);
  }

  function getGrupo() {
    return SessionState.sessionData.grupo;
  }
  function getAuthData() {
    return JSON.stringify(SessionState.sessionData);
  }
  function getDataST() {
    return localStorage.getItem("authData");
  }

  function clearStoreAuthData() {
    localStorage.removeItem("authData");

    SessionStateDispatch({
      type: "CLEAR_SESSION_DATA",
      payload: initialState,
    });
  }

  function getMenu() {
    return [...SessionState.sessionData.access];
  }

  function getuid() {
    return SessionState.sessionData.id;
  }
  function clearVariables() {
    //console.log('fue llamada otra vez');
    SessionState.sessionData.sessionvariable = [];
  }
  function getVariable(id) {
    //console.log('getVariable',id);
    let data;

    SessionState.sessionData.sessionvariable.forEach((element) => {
      for (var key in element) {
        if (key === id) {
          //console.log(id,key);
          data = element[key];
        }
      }
    });
    return data;
  }

  function getToken() {
    return SessionState.sessionData.token;
  }

  function ValidateAccess(acID, subacID, context) {
    let id;
    let subid;
    let suarr = [];
    SessionState.sessionData.access.forEach((el) => {
      if (el.length === 6) {
        id = +el[1];
        if (id === acID) {
        }
      } else {
        id = +el[0][1];
        suarr = el[1];
        if (suarr.length > 1)
          suarr.forEach((element) => {
            subid = element[3];
            if (subid === subacID) {
            }
          });
      }
    });
    //if(!flag)this.router.navigateByUrl(context,url);
  }
  const ctxValue = {
    sessionData: SessionState.sessionData,
    ip: "https://bei360.injupemp.gob.hn:8444/", //"http://172.20.7.11:8080",
    defaultMenu: SessionState.defaultMenu,
    dispatch: () => {},
    sessionStart: sessionStart,
    storeAuthData: storeAuthData,
    getGrupo: getGrupo,
    getAuthData: getAuthData,
    getDataST: getDataST,
    clearSession: clearStoreAuthData,
    setPath: setPath,
    setDataAuth: setDataAuth,
    getMenu: getMenu,
    getuid: getuid,
    setUsername: setUsername,
    setVariable: setVariable,
    clearVariables: clearVariables,
    getVariable: getVariable,
    getToken: getToken,
    ValidateAccess: ValidateAccess,
    getID: getID,
    setID: setID,
  };

  return (
    <ContextSession.Provider value={ctxValue}>
      {children}
    </ContextSession.Provider>
  );
}
